'use strict'

import angular from 'angular'
import ImportController from './import.controller'

export default angular.module('updateServerApp.devices.import', [])
  .controller('DevicesImportController', ImportController)
  .name



// WEBPACK FOOTER //
// ./client/app/devices/import/index.js